import React, { useState, useEffect } from 'react';
import { Card } from 'primereact/card';
import { Checkbox } from 'primereact/checkbox';
import { Divider } from 'primereact/divider';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { InputNumber } from 'primereact/inputnumber';
import { InputTextarea } from 'primereact/inputtextarea';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Tag } from 'primereact/tag';
import { useHistory } from 'react-router-dom';
import axios from 'axios';
import 'primeflex/primeflex.css';
import useGlobalState, { g_user, API_Root } from '../globalState';
import { TripFiles } from '../mobile/trip/TripFile';
import { AdditionalCharges } from './driver/AdditionalCharges';

export const TripDetails = (props) => {
   const [trip, setTrip] = useState();
   const [tripId, setTripId] = useState();
   const [userId, setUserId] = useState();
   const [showChecklist, setShowChecklist] = useState(false);
   const [isCompleting, setIsCompleting] = useState(false);
   const [confirmIndex, setConfirmIndex] = useState(0);
   const [confirmNotes, setConfirmNotes] = useState([]);
   const [actualMiles, setActualMiles] = useState();
   const [mileageNotes, setMileageNotes] = useState('');
   const [showMileageNotes, setShowMileageNotes] = useState(false);
   const [porter, setPorter] = useState();
   const [selectedVehicleId, setSelectedVehicleId] = useState();
   const [actionBusy, setActionBusy] = useState(false);
   const [rejected, setRejected] = useState(false);
   const [sessionMode, setSessionMode] = useState(false);
   const [showPauseConfirm, setShowPauseConfirm] = useState(false);
   const [user,] = useGlobalState(g_user);
   const history = useHistory();

   const applyTrip = (data, uid, preferredVehicleId) => {
      setTrip(data);
      setActualMiles(data.estimatedMiles);
      const mine = (data.TripVehicles || []).filter((p) => p.porterId == uid);
      const preferred = preferredVehicleId ? mine.find((p) => p.id == preferredVehicleId) : null;
      const assigned = preferred || mine.find((p) => !p.confirmed) || mine[0] || null;
      setPorter(assigned);
      if (assigned?.id) {
         setSelectedVehicleId(assigned.id);
      }
   };

   const loadTrip = (tid, uid, preferredVehicleId) => {
      var apiUrl = `${API_Root}api/trip/GetTrip?id=${tid}`;
      axios.get(apiUrl).then((values) => {
         if (values.data != null) {
            applyTrip(values.data, uid, preferredVehicleId);
         }
      });
   };

   useEffect(() => {
      const query = new URLSearchParams(props.location.search);
      const routeId = props.match?.params?.tripId;
      const tid = routeId || query.get('t');
      const uid = routeId ? user?.user?.id : query.get('u');
      const vid = query.get('vehicleId');
      const isSession = Boolean(routeId);

      setSessionMode(isSession);
      setRejected(false);

      if (!tid || !uid) {
         return;
      }

      setTripId(tid);
      setUserId(uid);
      if (vid) {
         setSelectedVehicleId(Number(vid));
      }
      loadTrip(tid, uid, vid);
   }, [props.match?.params?.tripId, props.location.search, user?.user?.id]);

   const refreshTrip = () => {
      loadTrip(tripId, userId, selectedVehicleId || porter?.id);
   };

   const vehicleParam = () => (porter?.id ? `&vehicleId=${porter.id}` : '');

   const confirmTrip = () => {
      setActionBusy(true);
      var apiUrl = `${API_Root}api/trip/ConfirmPorter?tripId=${tripId}&porterId=${userId}${vehicleParam()}`;
      axios.get(apiUrl).then(() => {
         setActionBusy(false);
         refreshTrip();
      }).catch(() => setActionBusy(false));
   };

   const rejectTrip = () => {
      setActionBusy(true);
      const rejectedId = porter?.id;
      var apiUrl = `${API_Root}api/trip/RejectPorter?tripId=${tripId}&porterId=${userId}${vehicleParam()}`;
      axios.get(apiUrl).then(() => {
         setActionBusy(false);
         const remaining = (trip?.TripVehicles || []).filter((p) => p.porterId == userId && p.id != rejectedId);
         if (remaining.length) {
            setSelectedVehicleId(remaining[0].id);
            loadTrip(tripId, userId, remaining[0].id);
         } else {
            setRejected(true);
            setPorter(null);
         }
      }).catch(() => setActionBusy(false));
   };

   const beginTrip = () => {
      setActionBusy(true);
      var apiUrl = `${API_Root}api/trip/BeginTrip?tripId=${tripId}&porterId=${userId}${vehicleParam()}`;
      axios.get(apiUrl).then((values) => {
         setActionBusy(false);
         refreshTrip();
         if (!values.data) {
            window.alert('You must confirm this assignment before beginning the trip.');
         }
      }).catch(() => setActionBusy(false));
   };

   const pickUpTrip = () => {
      setActionBusy(true);
      var apiUrl = `${API_Root}api/trip/PickUpTrip?tripId=${tripId}&porterId=${userId}${vehicleParam()}`;
      axios.get(apiUrl).then((values) => {
         setActionBusy(false);
         refreshTrip();
         if (!values.data) {
            window.alert('You must confirm this assignment before picking up.');
         }
      }).catch(() => setActionBusy(false));
   };

   const turnAroundTrip = () => {
      setActionBusy(true);
      var apiUrl = `${API_Root}api/trip/TurnAroundTrip?tripId=${tripId}&porterId=${userId}${vehicleParam()}`;
      axios.get(apiUrl).then(() => {
         setActionBusy(false);
         setShowChecklist(false);
         refreshTrip();
      }).catch(() => setActionBusy(false));
   };

   const submitComplete = (miles, notes) => {
      setActionBusy(true);
      const encoded = notes ? `&mileageNotes=${encodeURIComponent(notes)}` : '';
      const path = notes ? 'CompleteTripWithNotes' : 'CompleteTrip';
      var apiUrl = `${API_Root}api/trip/${path}?tripId=${tripId}&porterId=${userId}&actualMiles=${miles}${encoded}${vehicleParam()}`;
      axios.get(apiUrl).then(() => {
         setActionBusy(false);
         setShowChecklist(false);
         setShowMileageNotes(false);
         setMileageNotes('');
         refreshTrip();
      }).catch(() => setActionBusy(false));
   };

   const isHourly = (trip?.Dealership?.DealershipSettings?.[0]?.rateMethod ?? '').toLowerCase() === 'h';
   const tripPaused = !!porter?.TripVehiclePauses?.some((p) => !p.endDateTime);
   const totalPauseMinutes = (porter?.TripVehiclePauses ?? []).reduce((sum, p) => sum + (p.durationMinutes ?? 0), 0);

   const formatPauseDuration = (minutes) => {
      if (minutes < 60) {
         return `${minutes} minute${minutes === 1 ? '' : 's'}`;
      }
      const hours = Math.floor(minutes / 60);
      const remaining = minutes % 60;
      const hourLabel = `${hours} hour${hours === 1 ? '' : 's'}`;
      if (remaining === 0) {
         return hourLabel;
      }
      return `${hourLabel} ${remaining} minute${remaining === 1 ? '' : 's'}`;
   };

   const pauseTrip = () => {
      setShowPauseConfirm(false);
      setActionBusy(true);
      var apiUrl = `${API_Root}api/trip/PauseTrip?tripId=${tripId}&porterId=${userId}${vehicleParam()}`;
      axios.get(apiUrl).then(() => {
         setActionBusy(false);
         refreshTrip();
      }).catch(() => setActionBusy(false));
   };

   const resumeTrip = () => {
      setActionBusy(true);
      var apiUrl = `${API_Root}api/trip/ResumeTrip?tripId=${tripId}&porterId=${userId}${vehicleParam()}`;
      axios.get(apiUrl).then(() => {
         setActionBusy(false);
         refreshTrip();
      }).catch(() => setActionBusy(false));
   };

   const completeTrip = () => {
      const miles = Number(actualMiles) || 0;
      const limit = (trip?.estimatedMiles || 0) * 2;
      if (limit > 0 && miles > limit) {
         setShowChecklist(false);
         setShowMileageNotes(true);
         return;
      }
      submitComplete(miles, null);
   };

   const completeTripWithNotes = () => {
      if (!mileageNotes || mileageNotes.trim().length === 0) {
         return;
      }
      submitComplete(Number(actualMiles) || 0, mileageNotes.trim());
   };

   const splitOnCR = (s) => {
      if (!s || s.trim().length === 0) {
         return [];
      }
      return s.split(/\r?\n/).map((n) => n.trim()).filter((n) => n.length > 0);
   };

   const openChecklist = (toComplete) => {
      let notes = [];
      setIsCompleting(toComplete);

      if (toComplete) {
         notes.push('All additional charges and receipts have been added');
      }
      else {
         trip.TripPorterNotes?.forEach((n) => {
            if (n.PorterNotesLookup?.note) {
               notes.push(n.PorterNotesLookup.note);
            }
         });
         splitOnCR(trip.porterNotes).forEach((n) => notes.push(n));
      }

      if (notes.length === 0 && !toComplete) {
         turnAroundTrip();
         return;
      }

      setConfirmNotes(notes);
      setConfirmIndex(0);
      setShowChecklist(true);
   };

   const confirmNote = () => {
      let newIndex = confirmIndex + 1;
      if (newIndex >= confirmNotes.length) {
         if (isCompleting) {
            setConfirmIndex(-1);
         }
         else {
            setShowChecklist(false);
            turnAroundTrip();
         }
      }
      else {
         setConfirmIndex(newIndex);
      }
   };

   const formatDate = (dt) => {
      var d = new Date(dt);
      return d.toLocaleDateString('en-US', {
         day: '2-digit',
         month: '2-digit',
         year: 'numeric',
         hour: '2-digit',
         minute: '2-digit',
         hour12: true
      });
   };

   const formatTime = (dt) => {
      var d = new Date(dt);
      return d.toLocaleTimeString('en-US', {
         hour: '2-digit',
         minute: '2-digit',
         hour12: true
      });
   };

   const formatBool = (b) => {
      return b ? 'Yes' : 'No';
   };

   const vehicleMilestones = (v) => {
      const items = [];
      if (v.pickedUpDateTime) {
         items.push({ label: 'Picked up', at: v.pickedUpDateTime });
      }
      if (v.actualDepartDateTime) {
         items.push({ label: 'Began trip', at: v.actualDepartDateTime });
      }
      if (v.turnAroundTime) {
         items.push({ label: 'Turned around', at: v.turnAroundTime });
      }
      if (v.completedDateTime) {
         items.push({ label: 'Completed', at: v.completedDateTime });
      }
      if (isHourly && v.completed) {
         const minutes = (v.TripVehiclePauses ?? []).reduce((sum, p) => sum + (p.durationMinutes ?? 0), 0);
         items.push({ label: 'Pause duration', at: formatPauseDuration(minutes), raw: true });
      }
      return items;
   };

   const porterListTemplate = (p) => {
      let type;
      if (!p.User) {
         type = <Tag severity="warning" value="Unassigned"></Tag>;
      }
      else if (!p.confirmed) {
         type = <Tag severity="warning" value="Unconfirmed"></Tag>;
      }
      else if (p.isChase) {
         type = <Tag severity="success" value="Chase"></Tag>;
      }
      else {
         type = <Tag severity="info" value="Driver"></Tag>;
      }

      const mine = p.porterId == userId;
      const selected = mine && porter?.id == p.id;

      return (
         <div
            key={p.id}
            className={`driver-trip-vehicle${selected ? ' selected' : ''}${mine ? ' selectable' : ''}`}
            onClick={() => {
               if (mine) {
                  setSelectedVehicleId(p.id);
                  setPorter(p);
               }
            }}
         >
            <div className="w-full mt-2">
               <span className="font-bold">{p.vehicleVIN}</span> - {p.vehicleYear} {p.vehicleMake} {p.vehicleModel}
            </div>
            <div className="flex flex-row flex-wrap">
               {p.User && (
                  <>
                     <div className="mr-4">
                        {p.User.firstName} {p.User.lastName}
                     </div>
                     <div className="mr-4">
                        <a href={"tel:" + p.User.phone}>{p.User.phone}</a>
                     </div>
                  </>
               )}
               <div className="mr-4">
                  {type}
               </div>
            </div>
            {vehicleMilestones(p).map((m) => (
               <div key={m.label} className="text-sm text-color-secondary">
                  {m.label}: {m.raw ? m.at : formatDate(m.at)}
               </div>
            ))}
         </div>
      );
   };

   const getActionMessage = () => {
      const mineCount = (trip?.TripVehicles || []).filter((v) => v.porterId == userId).length;
      const vehicleLabel = `${porter?.vehicleYear ?? ''} ${porter?.vehicleMake ?? ''} ${porter?.vehicleModel ?? ''}`.trim();
      const forVehicle = mineCount > 1 && vehicleLabel ? ` for ${vehicleLabel}` : '';
      if (rejected) {
         return 'This assignment has been rejected.';
      }
      if (!porter?.confirmed) {
         return `You have been assigned to this trip. Please confirm or reject this assignment${forVehicle}.`;
      }
      if (!porter?.pickedUpDateTime && !porter?.actualDepartDateTime) {
         return `Mark picked up when you have the vehicle${forVehicle}.`;
      }
      if (!porter?.actualDepartDateTime) {
         return `Your trip is confirmed. Begin it when you leave the source location${forVehicle}.`;
      }
      if (tripPaused) {
         return 'Trip is paused. Time is not being billed until you resume.';
      }
      if (!porter.turnAroundTime) {
         return 'Start the return when you have arrived at the destination.';
      }
      if (!porter.completed) {
         return 'Complete this trip when you are finished. Add charges and receipts first.';
      }
      if (isHourly) {
         return `This trip has been completed. Pause duration: ${formatPauseDuration(totalPauseMinutes)}`;
      }
      return 'This trip has been completed.';
   };

   const getButtons = () => {
      if (rejected) {
         return null;
      }
      if (!porter?.confirmed) {
         return (<>
            <Button className="mr-2" label="Reject" onClick={() => rejectTrip()} disabled={actionBusy}></Button>
            <Button label="Confirm" onClick={() => confirmTrip()} loading={actionBusy} disabled={actionBusy}></Button>
         </>);
      }
      if (!porter?.pickedUpDateTime && !porter?.actualDepartDateTime) {
         return (<Button label="Picked Up" onClick={() => pickUpTrip()} loading={actionBusy} disabled={actionBusy}></Button>);
      }
      if (!porter?.actualDepartDateTime) {
         return (<Button label="Begin Trip" onClick={() => beginTrip()} loading={actionBusy} disabled={actionBusy}></Button>);
      }
      const pauseButton = isHourly && !porter.completed
         ? (tripPaused
            ? <Button className="mr-2" label="Resume Trip" onClick={() => resumeTrip()} loading={actionBusy} disabled={actionBusy}></Button>
            : <Button className="mr-2 p-button-outlined" label="Pause Trip" onClick={() => setShowPauseConfirm(true)} disabled={actionBusy}></Button>)
         : null;
      if (!porter.turnAroundTime) {
         return (<>
            {pauseButton}
            <Button label="Start Return" onClick={() => openChecklist(false)} loading={actionBusy} disabled={actionBusy}></Button>
         </>);
      }
      if (!porter.completed) {
         return (<>
            {pauseButton}
            <Button label="Complete Trip" onClick={() => openChecklist(true)} disabled={actionBusy}></Button>
         </>);
      }
      return null;
   };

   const getChecklistContent = () => {
      if (isCompleting && (confirmIndex === -1 || confirmIndex >= confirmNotes.length)) {
         return <div>
            <div className="w-full flex justify-content-start align-items-center">
               <div className="mr-2">Actual miles</div>
               <div><InputNumber value={actualMiles} onValueChange={(e) => setActualMiles(e.value)} /></div>
            </div>
            <div className="w-full text-right mt-4">
               <Button label="Complete Trip" onClick={() => completeTrip()} loading={actionBusy} disabled={actionBusy}></Button>
            </div>
         </div>;
      }
      return <div className="w-full">
         <div className="w-full font-semibold text-left mb-2">
            Please confirm that each note has been completed
         </div>
         <div className="w-full flex justify-content-start">
            <div className="mr-2"><Checkbox checked={false} onChange={() => confirmNote()} /></div>
            <div>{confirmNotes[confirmIndex]}</div>
         </div>
      </div>;
   };

   const backBar = () => {
      if (!sessionMode) {
         return null;
      }
      return (
         <div className="mb-3">
            <Button
               label="My Trips"
               icon="pi pi-arrow-left"
               text
               onClick={() => history.push('/my-trips')}
            />
         </div>
      );
   };

   if (trip && (porter || rejected)) {
      return (
         <div className="driver-trip-page">
            {backBar()}
            <Card>
               <div className="driver-trip-header">
                  <div className="driver-trip-header-msg">{getActionMessage()}</div>
                  <div className="driver-trip-header-actions">
                     {getButtons()}
                  </div>
               </div>
               <h3 className="driver-trip-title">Trip for {trip.Dealership?.dealershipName}</h3>
               <Divider />
               <div className="driver-trip-meta">
                  <div>
                     <span className="font-bold">Depart: </span>{formatDate(trip.departDateTimeStart)} - {formatTime(trip.departDateTimeEnd)}
                  </div>
                  <div>
                     <span className="font-bold">Arrive: </span>{formatDate(trip.requestedDeliveryDateTime)} - {formatTime(trip.requestedDeliveryDateTimeEnd)}
                     {trip.pickupDateTime ? (
                        <div className="mt-1">
                           <span className="font-bold">Pickup available: </span>{formatDate(trip.pickupDateTime)}
                        </div>
                     ) : null}
                  </div>
                  <div>
                     <span className="font-bold">Number of Vehicles: </span>{trip.TripVehicles.length}
                  </div>
                  <div>
                     <span className="font-bold">Chase Car: </span>{formatBool(trip.roundTrip)}
                  </div>
               </div>
               <Divider />
               <div className="driver-trip-locations">
                  <div>
                     <div className="driver-trip-label">Source</div>
                     <div>{trip.Dealership2?.dealershipName ?? "Private address"}</div>
                     <div>{trip.Dealership2?.streetAddress}</div>
                     <div>{trip.Dealership2?.city} {trip.Dealership2?.stateAbbr} {trip.Dealership2?.zipCode}</div>
                  </div>
                  <div>
                     <div className="driver-trip-label">Destination</div>
                     <div>{trip.Dealership1?.dealershipName ?? "Private address"}</div>
                     <div>{trip.Dealership1?.streetAddress}</div>
                     <div>{trip.Dealership1?.city} {trip.Dealership1?.stateAbbr} {trip.Dealership1?.zipCode}</div>
                  </div>
               </div>
               <Divider />
               <div className="driver-trip-split">
                  <div>
                     <div className="driver-trip-label">Vehicles and drivers</div>
                     {trip?.TripVehicles?.map((p) => {
                        return porterListTemplate(p);
                     })}
                  </div>
                  <div>
                     <div className="driver-trip-label">Porter notes</div>
                     <ul className="driver-trip-notes">
                        {trip.TripPorterNotes?.map((n, i) => {
                           return (<li key={i}>{n.PorterNotesLookup.note}</li>);
                        })}
                        {splitOnCR(trip.porterNotes)?.map((n, i) => {
                           return (<li key={"custom" + i}>{n}</li>);
                        })}
                     </ul>
                  </div>
               </div>
               {porter && (trip?.TripVehicles || []).some((v) => v.porterId == userId && v.pickedUpDateTime) && (
                  <>
                     <Divider />
                     <div className="driver-trip-split">
                        <div>
                           <div className="driver-trip-label">Additional charges</div>
                           <AdditionalCharges tripId={tripId} userId={userId} canEdit />
                        </div>
                        <div>
                           <div className="driver-trip-label">Receipts and files</div>
                           <TripFiles userId={userId} tripId={tripId} canEdit></TripFiles>
                        </div>
                     </div>
                  </>
               )}
               <Dialog
                  header={isCompleting ? 'Complete Trip' : 'Start Return'}
                  visible={showChecklist}
                  className="sm:w-11 md:w-6 lg:w-4 xl:w-4"
                  onHide={() => setShowChecklist(false)}>
                  <div className="w-full text-left mt-2">
                     {getChecklistContent()}
                  </div>
               </Dialog>
               <Dialog
                  header="Pause trip"
                  visible={showPauseConfirm}
                  className="sm:w-11 md:w-6 lg:w-4"
                  onHide={() => { if (!actionBusy) setShowPauseConfirm(false); }}>
                  <p>Pause this trip? Time spent while paused will be deducted from the billed hours.</p>
                  <div className="text-right mt-3">
                     <Button
                        className="mr-2 p-button-text"
                        label="Cancel"
                        onClick={() => setShowPauseConfirm(false)}
                        disabled={actionBusy}
                     />
                     <Button
                        label="Pause"
                        onClick={() => pauseTrip()}
                        loading={actionBusy}
                        disabled={actionBusy}
                     />
                  </div>
               </Dialog>
               <Dialog
                  header="Mileage notes required"
                  visible={showMileageNotes}
                  className="sm:w-11 md:w-6 lg:w-4"
                  onHide={() => { if (!actionBusy) setShowMileageNotes(false); }}>
                  <p>Actual miles are more than twice the estimate. Please explain the extra mileage.</p>
                  <InputTextarea
                     className="w-full"
                     rows={4}
                     value={mileageNotes}
                     onChange={(e) => setMileageNotes(e.target.value)}
                  />
                  <div className="text-right mt-3">
                     <Button
                        label="Complete Trip"
                        onClick={() => completeTripWithNotes()}
                        loading={actionBusy}
                        disabled={actionBusy || !mileageNotes.trim()}
                     />
                  </div>
               </Dialog>
            </Card>
         </div>
      );
   }

   if (trip && !porter) {
      return (
         <div className="driver-trip-page">
            {backBar()}
            <Card className="text-center">You are not assigned to this trip</Card>
         </div>
      );
   }

   return (
      <div className="driver-trip-page">
         {backBar()}
         <Card className="text-center"><ProgressSpinner /></Card>
      </div>
   );
};
